import { render, staticRenderFns } from "./InputLayout.vue?vue&type=template&id=a558c4fa&scoped=true"
import script from "./InputLayout.vue?vue&type=script&lang=js"
export * from "./InputLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a558c4fa",
  null
  
)

export default component.exports